import type { ThemeOptions } from '@mui/material';
import { createTheme } from '@mui/material';

const typography: ThemeOptions['typography'] = {
  fontFamily: 'IRANSansFaNum, IRANSans, sans-serif',
  // Landing Title
  h1: {
    fontSize: 44,
    lineHeight: '72px',
    fontWeight: 500,
  },
  // Large Text
  h2: {
    fontSize: 34,
    lineHeight: '46px',
    fontWeight: 500,
  },
  // Title 1
  h3: {
    fontSize: 28,
    lineHeight: '38px',
    fontWeight: 500,
  },
  // Title 2
  h4: {
    fontSize: 22,
    lineHeight: '34px',
    fontWeight: 500,
  },
  // Title 3
  h5: {
    fontSize: 20,
    lineHeight: '36px',
    fontWeight: 500,
  },
  // Headline
  h6: {
    fontSize: 17,
    lineHeight: '27px',
    fontWeight: 700,
  },
  // Body
  body1: {
    fontSize: 16,
    lineHeight: '27px',
  },
  // Callout
  body2: {
    fontSize: 14,
    lineHeight: '25px',
  },
  // Subhead
  subtitle1: {
    fontSize: 15,
    lineHeight: '24px',
  },
  // Footnote
  subtitle2: {
    fontSize: 13,
    lineHeight: '20px',
  },
  // Caption
  caption: {
    fontSize: 12,
    lineHeight: '18px',
  },
};

const themeOptions: ThemeOptions = {
  direction: 'rtl',
  typography,
  palette: {
    primary: {
      light: '#E6E6F8',
      main: '#0800B6',
    },
    secondary: {
      main: '#2194F3',
    },
    error: {
      main: '#FF0022',
    },
    success: {
      main: '#20BF55',
    },
    warning: {
      main: '#F7B801',
    },
  },
  components: {
    MuiButton: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        sizeMedium: {
          fontWeight: 'bold',
          paddingLeft: '24px',
          paddingRight: '24px',
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: {
          padding: '4px 32px 32px 32px',
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          padding: '8px 32px 32px 32px',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          padding: '32px 32px 4px 32px',
        },
      },
    },
    MuiFormControlLabel: {
      defaultProps: {
        componentsProps: {
          typography: {
            variant: 'body2',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        shrink: {
          transform: 'translate(14px, -9px) scale(0.66)',
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          ...typography.body2,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          justifyContent: 'center',
        },
      },
    },
    MuiSelect: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          position: 'relative',
          ':before': {
            content: '""',
            position: 'absolute',
            bottom: 0,
            width: '100%',
            height: 1,
            background: '#DFDFDF', //FIXME: Use divider color
          },
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
  },
};

export const theme = createTheme(themeOptions);
